import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { CheckCircle, AlertTriangle } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const UnsubscribeAlert = () => {
  const { searchId } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!searchId || !token) {
      setStatus('error');
      return;
    }
    axios.delete(`${API}/api/classifieds/saved-searches/${searchId}?token=${token}`)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [searchId, token]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-sm p-8 max-w-md w-full text-center border border-gray-100">
        {status === 'loading' && (
          <div className="animate-pulse">
            <div className="h-12 w-12 bg-gray-200 rounded-full mx-auto mb-4"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto"></div>
          </div>
        )}
        {status === 'success' && (
          <>
            <div className="w-14 h-14 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="h-7 w-7 text-emerald-600" />
            </div>
            <h1 className="text-lg font-bold text-gray-900 mb-2" data-testid="unsubscribe-success">
              {t('savedSearch.unsubscribed', 'Unsubscribed')}
            </h1>
            <p className="text-sm text-gray-600 mb-6">
              {t('savedSearch.unsubscribedDesc', 'You will no longer receive notifications for this search.')}
            </p>
            <button onClick={() => navigate('/classifieds')}
              className="px-6 py-2.5 bg-emerald-600 text-white rounded-lg font-medium hover:bg-emerald-700 text-sm"
              data-testid="back-to-classifieds-btn">
              {t('savedSearch.backToClassifieds', 'Browse Sell / Lost / Found')}
            </button>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="h-7 w-7 text-amber-600" />
            </div>
            <h1 className="text-lg font-bold text-gray-900 mb-2" data-testid="unsubscribe-error">
              {t('savedSearch.unsubscribeError', 'Could not unsubscribe')}
            </h1>
            <p className="text-sm text-gray-600 mb-6">
              {t('savedSearch.unsubscribeErrorDesc', 'This link may have expired or already been used.')}
            </p>
            <button onClick={() => navigate('/classifieds')}
              className="px-6 py-2.5 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 text-sm">
              {t('savedSearch.backToClassifieds', 'Browse Sell / Lost / Found')}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default UnsubscribeAlert;
